export default __webpack_public_path__ + "static/media/yellow-star.118f5c2d.png";